import TreeConnector from '@components/ListV2/components/table/tree/TreeConnector';
import { STROKE_WIDTH, SVG_W, TRUNK_X } from '@components/ListV2/components/table/tree/tree.consts';
import HiddenValueDots from '@components/v2/ui/HiddenValueDots/HiddenValueDots';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';
import {
  ORDER_TOTALS_SUMMARY_GAP,
  ORDER_TOTALS_SUMMARY_NESTED_GAP,
} from '../orderTotalsSummary.consts';

interface OrderTotalsSummaryRowProps {
  label: string;
  value: ReactNode;
  isNested?: boolean;
  isLastNested?: boolean;
  isEmphasized?: boolean;
  isValueHidden?: boolean;
  valueTestId?: string;
}

const OrderTotalsSummaryRow = ({
  label,
  value,
  isNested,
  isLastNested,
  isEmphasized,
  isValueHidden,
  valueTestId,
}: OrderTotalsSummaryRowProps) => (
  <Stack
    direction="row"
    sx={{
      position: 'relative',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      columnGap: 2.5,
      marginLeft: isNested ? `${SVG_W}px` : 0,
      marginTop: isNested ? ORDER_TOTALS_SUMMARY_NESTED_GAP - ORDER_TOTALS_SUMMARY_GAP : 0,
    }}
  >
    {isNested && (
      <Box
        sx={(theme) => ({
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          color: 'custom.border.primary',
          '&::before': {
            content: '""',
            position: 'absolute',
            left: `${TRUNK_X - SVG_W - STROKE_WIDTH / 2}px`,
            bottom: '100%',
            height: theme.spacing(ORDER_TOTALS_SUMMARY_NESTED_GAP),
            borderLeft: `${STROKE_WIDTH}px solid currentColor`,
          },
        })}
      >
        <TreeConnector isLastChild={!!isLastNested} />
      </Box>
    )}

    <Typography noWrap variant="body2" sx={{ color: 'text.secondary', flex: 1, minWidth: 0 }}>
      {label}
    </Typography>
    <Box sx={{ position: 'relative', flexShrink: 0 }}>
      <Typography
        variant="body2"
        component="span"
        testId={valueTestId}
        sx={{
          display: 'block',
          color: 'text.primary',
          fontWeight: isEmphasized ? 600 : undefined,
          whiteSpace: 'nowrap',
          visibility: isValueHidden ? 'hidden' : undefined,
        }}
      >
        {value}
      </Typography>

      {isValueHidden && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            color: 'text.primary',
          }}
        >
          <HiddenValueDots />
        </Box>
      )}
    </Box>
  </Stack>
);

export default OrderTotalsSummaryRow;
